function formatPrice(price, locale = 'en-US') {
  return (price / 100).toLocaleString(locale, {
    style: 'currency',
    currency: 'USD',
  });
}

export default formatPrice;
